package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import org.lennycodes.hldi.constants.HLDITheme

val PaymentMethodsCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.white)

            .borderRadius(12.px)
            .boxShadow(0.px, 4.px, 12.px, color = Color.rgba(0, 0, 0, 0.1f))
    }
}

val PaymentMethodsHeadingStyle = CssStyle {
    base {
        Modifier
            .fontSize(24.px)
            .color(HLDITheme.Colors.primary)
            .margin(bottom = 24.px)
            .fontFamily("Playfair Display", "serif")
    }
}

// Wraps each method (Mobile Money, Bank Transfer) with a color-coded left accent
val PaymentMethodBlockStyle = CssStyle {
    base {
        Modifier
            .styleModifier { property("border-left", "3px solid ${HLDITheme.Colors.secondary}") }

    }
}

val PaymentMethodHeadingStyle = CssStyle {
    base {
        Modifier
            .fontSize(16.px)
            .fontWeight(700)
            .color(HLDITheme.Colors.secondary)
            .margin(bottom = 16.px)
            .styleModifier { property("letter-spacing", "0.02em") }
    }
}

// Each row: small muted label on top, bold monospace value below
val PaymentRowStyle = CssStyle {
    base {
        Modifier
            .styleModifier { property("border-bottom", "1px solid ${HLDITheme.Colors.background}") }
    }
}

val PaymentLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .color(HLDITheme.Colors.text)
            .styleModifier {
                property("text-transform", "uppercase")
                property("letter-spacing", "0.05em")
                property("opacity", "0.6")
            }
    }
}

val PaymentValueStyle = CssStyle {
    base {
        Modifier
            .fontSize(15.px)
            .fontWeight(600)
            .color(HLDITheme.Colors.primary)
            .fontFamily("SF Mono", "Consolas", "monospace")
            .margin(top = 4.px)
    }
}